import { AbstractControl } from '@angular/forms';
export class CustomValidator {
  // Validates DC Name
  static deepConfigNameValidator(dcName) {
    if (dcName.pristine) {
      return null;
    }
    const DC_NAME_REGEXP = /^[a-zA-Z0-9-_]*$/;
    dcName.markAsTouched();
    if (DC_NAME_REGEXP.test(dcName.value)) {
      return null;
    }
    return {
      invalidDcName: true
    };
  }

  // checks for presence of http
  static secureUrlValidator(url): any {
    if (url.pristine) {
      return null;
    }
    const regex = /http(?!s).*/i;
    if (regex.test(url.value)) {
      return {
        unsecuredUrl: true
      };
    }
    return null;
  }

  // Validates URL
  static urlValidator(url): any {
    if (url.pristine) {
      return null;
    }
    // tslint:disable-next-line:max-line-length
    const URL_REGEXP = /^(?:(?:(?:https?|ftp):)?\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:[/?#]\S*)?$/;
    const validWildcardUrl = /^((https?|ftp):\/\/localhost)$/;
    url.markAsTouched();
    if (URL_REGEXP.test(url.value) || validWildcardUrl.test(url.value)) {
      return null;
    }
    return {
      invalidUrl: true
    };
  }

  // Validates passwords
  static matchPassword(AC: AbstractControl) {
    const password = AC.get('newPassword').value; // to get value in input tag
    const confirmPassword = AC.get('confirmPassword').value; // to get value in input tag
    if (password !== confirmPassword) {
      AC.get('confirmPassword').setErrors({ invalidPassword: true });
    } else {
      return null;
    }
  }

  // Validates numbers
  static numberValidator(number): any {
    if (number.pristine) {
      return null;
    }
    if (number.value > 2147483647 || number.value < -2147483648) {
      return {
        invalidNumber: 'Number out of bounds'
      };
    }
    const NUMBER_REGEXP = /^-?[\d.]+(?:e-?\d+)?$/;
    number.markAsTouched();
    if (NUMBER_REGEXP.test(number.value)) {
      return null;
    }
    return {
      invalidNumber: 'Enter a valid Number'
    };
  }

  // Validates domain
  static domainValidator(domain): any {
    if (domain.pristine) {
      return null;
    }

    // any valid domain OR single word OR '*'
    const validHostnameRegex = /^[a-zA-Z0-9-]+(\.[a-zA_Z0-9-]+)*$/;
    const validWildcardDomain = /^[*]$/;
    domain.markAsTouched();
    domain.value = domain.value && domain.value.toLowerCase();
    if (validHostnameRegex.test(domain.value) || validWildcardDomain.test(domain.value)) {
      return null;
    }
    return {
      invalidDomain: true
    };
  }

  static customUrlValidator(customUrl): any {
    if (customUrl.pristine) {
      return null;
    }

    // any valid url'
    const validRegex = /^([a-z0-9-]+(\.[a-z0-9-]+)*)$/;
    customUrl.markAsTouched();
    customUrl.value = customUrl.value && customUrl.value.toLowerCase();
    if (validRegex.test(customUrl.value)) {
      return null;
    }
    return {
      invalidCustomUrl: true
    };
  }

  static noWhitespaceValidator(strValiue): any {
    if (strValiue.pristine) {
      return null;
    }

    const isWhitespace = (strValiue.value || '').trim().length === 0;
    const isValid = !isWhitespace;

    if (isValid) {
      return null;
    }
    return {
      invalidValue: true
    };
  }

  static emailSpecialCharValidator(email): any {
    if (email.pristine) {
      return null;
    }

    const EMAIL_REGEXP = /^[a-zA-Z0-9-_.+@]*$/;
    email.markAsTouched();

    if (EMAIL_REGEXP.test(email.value)) {
      return null;
    }
    return {
      invalidCharError: true
    };
  }

  static userNameDomainSpecialCharValidator(email): any {
    if (email.pristine) {
      return null;
    }

    const EMAIL_REGEXP = /^[a-zA-Z0-9- _]*$/;
    email.markAsTouched();

    if (EMAIL_REGEXP.test(email.value)) {
      return null;
    }
    return {
      invalidCharError: true
    };
  }

  static emailValidator(email): any {
    if (email.pristine) {
      return null;
    }

    email.value = email.value.toLowerCase();
    const emailBlackList = ['@gmail[.]', '@yahoo[.]', '@hotmail[.]', '@outlook[.]', '@rediffmail[.]'];
    const isEmailBlackListed = new RegExp(emailBlackList.join('|')).test(email.value);
    // tslint:disable-next-line:max-line-length
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    const isEmailValid = (re.test(email.value) && !(isEmailBlackListed));

    email.markAsTouched();

    if (isEmailValid) {
      return null;
    }
    return {
      invalidEmail: true
    };
  }

  static companyNameValidator(cName): any {
    if (cName.pristine) {
      return null;
    }
    const regex = /^[0-9A-Za-z-&#;:,.($₹€) ]+$/;
    cName.markAsTouched();
    if (regex.test(cName.value)) {
      return null;
    }
    return {
      invalidCompanyName: true
    };
  }
}
